<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar color="primary" class="topbar telative">
    <!-- ============================================================== -->
    <!-- Logo - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="navbar-header" fxLayoutAlign="center center">
      <a class="navbar-brand" href="index.html">
        <!-- Logo icon -->
        <b>
          <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
          <!-- Dark Logo icon -->
          <!-- <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo"> -->
          <!-- Light Logo icon -->
          <!-- <img src="assets/images/logo-light-icon.png" alt="homepage" class="light-logo"> -->
          <img src="../../../assets/images/RC_Blanco.png" alt="homepage" class="light-logo" style="height: 35px">
        </b>
        <!--End Logo icon -->
        <!-- Logo text -->
        <!-- <span fxShow="false" fxShow.gt-xs> -->
        <!-- dark Logo text -->
        <!-- <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo"> -->
        <!-- Light Logo text -->
        <!-- <span class="light-logo" alt="homepage" style="
                 color:  white;
                 margin-left:  10px;
             ">Registro Civil</span> -->
        <!-- <img src="assets/images/logo-light-text.png" class="light-logo" alt="homepage"> -->
        <!-- </span> -->
      </a>
    </div>

    <!-- ============================================================== -->
    <!-- sidebar toggle -->
    <!-- ============================================================== -->

    <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed">
      <mat-icon>menu</mat-icon>
    </button>

    <button mat-button [matMenuTriggerFor]="menu">{{sectionalType.name}} <mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #menu="matMenu">
      <a href="" mat-menu-item (click)="changeSectionalType({})">Todos</a>
      <a href="" mat-menu-item *ngFor="let type of sectionalTypes" (click)="changeSectionalType(type)">{{ type.name }}</a>
    </mat-menu>

    <span fxFlex></span>
    <!-- ============================================================== -->
    <!-- app header component - style you can find in header.scss / header.component.ts-->
    <!-- ============================================================== -->
    <app-header></app-header>
  </mat-toolbar>
  <mat-progress-bar color="warn" *ngIf="request()" mode="indeterminate"></mat-progress-bar>
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'"
      fixedTopGap="0" [opened]="mobileQuery.matches" style="
      overflow-x:hidden;
      overflow-y:visible;" [disableClose]="mobileQuery.matches">

      <app-sidebar></app-sidebar>


    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper">

      <div class="page-content">

        <router-outlet>
          <app-spinner></app-spinner>
        </router-outlet>

      </div>

    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>
<!-- <div style="width:100%;" fxLayout="row" fxLayoutWrap="wrap">
  <img style="position:absolute;bottom:-50px; width: 100%; z-index: 999;" src="../../assets/images/Footer-1.png" alt="">
</div> -->